/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum RankEnum {
  收礼榜 = 0,
  贡献榜 = 1,
}

export enum StageEnum {
  预热期间 = 0,
  pk期间 = 1,
}

export enum StatusEnum {
  正常 = 0,
  即将升级 = 1,
  即将降级 = 2,
}

export const competition_room_rank = createAsyncThunk(
  'pk/competition_room_rank',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_room_rank',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        // debug: true,
        // status: 0,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_support_list = createAsyncThunk(
  'pk/competition_support_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_support_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data?.list || []
  }
)
export const competition_rank_history = createAsyncThunk(
  'pk/competition_rank_history',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_rank_history',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_rule_pop = createAsyncThunk(
  'pk/competition_rule_pop',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_rule_pop',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_rank_get_avatar = createAsyncThunk(
  'pk/competition_rank_get_avatar',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_rank_get_avatar',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_selected_time = createAsyncThunk(
  'pk/competition_selected_time',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_selected_time',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_limit_time_challenge = createAsyncThunk(
  'pk/competition_limit_time_challenge',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_limit_time_challenge',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export const set_competition_selected_time = createAsyncThunk(
  'pk/set_competition_selected_time',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/set_competition_selected_time',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const competition_record_detail = createAsyncThunk(
  'pk/competition_record_detail',
  async (room_id: number, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_record_detail',
      {
        ...store.getState().env.deviceinfo,
        room_id,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const competition_common_rank_receive = createAsyncThunk(
  'pk/competition_common_rank_receive',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_common_rank',
      {
        ...store.getState().env.deviceinfo,
        type: RankEnum.收礼榜,
        // debug: true,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const competition_common_rank_send = createAsyncThunk(
  'pk/competition_common_rank_send',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/pk/competition_common_rank',
      {
        ...store.getState().env.deviceinfo,
        type: RankEnum.贡献榜,
        // debug: true,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  home: any
  send: any
  receive: any
  charm: any
} = {
  home: {},
  send: {},
  receive: {},
  charm: {},
}

export function usePk() {
  return useSelector((store) => store.Pk)
}

export const PkSlice = createSlice({
  name: 'pk',
  initialState,
  reducers: {
    updateOwnAvatars: (state, action) => {
      const {home} = state
      Object.assign(state.home, {
        own: {
          ...home.own,
          ...action.payload,
        },
      })
    },
    updateListAvatars: (state, action) => {
      const {home} = state
      const {curTab, cnt, avatars, count} = action.payload
      const res = home.list.slice()
      res[curTab].list[cnt].avatars = avatars
      res[curTab].list[cnt].count = count
      Object.assign(state.home, {
        list: res,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(competition_room_rank.fulfilled, (state, action) => {
      const {
        stage,
        track_list,
        list,
        before_list,
        my_rank,
        before_my_rank,
        ...rest
      } = action.payload
      const own = stage === StageEnum.预热期间 ? before_my_rank : my_rank
      const curList = (stage === StageEnum.预热期间 ? before_list : list) || []
      const res = []
      for (let i = 0; i < track_list?.length; i++) {
        res.push({
          name: track_list[i],
          list: curList[i],
        })
        for (let j = 0; j < curList[i]?.length; j++) {
          if (curList[i][j]?.mid === own?.mid) {
            own.groupName = track_list[i]
          }
        }
      }
      Object.assign(state.home, {
        ...rest,
        track_list,
        own: own || {},
        list: res,
        stage,
      })
    })
    builder.addCase(
      competition_common_rank_receive.fulfilled,
      (state, action) => {
        Object.assign(state.receive, action.payload)
      }
    )
    builder.addCase(competition_common_rank_send.fulfilled, (state, action) => {
      Object.assign(state.send, action.payload)
    })
    builder.addCase(
      competition_limit_time_challenge.fulfilled,
      (state, action) => {
        Object.assign(state.charm, action.payload)
      }
    )
  },
})

export default PkSlice.reducer
export const PkActions = PkSlice.actions
